/* @generated */
const tokens = {
  "Spacing": {
    "Dimension": {
      "0": "var(--dig-spacing__dimension__0)",
      "2": "var(--dig-spacing__dimension__2)",
      "4": "var(--dig-spacing__dimension__4)",
      "6": "var(--dig-spacing__dimension__6)",
      "8": "var(--dig-spacing__dimension__8)",
      "10": "var(--dig-spacing__dimension__10)",
      "12": "var(--dig-spacing__dimension__12)",
      "16": "var(--dig-spacing__dimension__16)",
      "20": "var(--dig-spacing__dimension__20)",
      "24": "var(--dig-spacing__dimension__24)",
      "28": "var(--dig-spacing__dimension__28)",
      "32": "var(--dig-spacing__dimension__32)",
      "36": "var(--dig-spacing__dimension__36)",
      "44": "var(--dig-spacing__dimension__44)",
      "52": "var(--dig-spacing__dimension__52)",
      "60": "var(--dig-spacing__dimension__60)",
      "68": "var(--dig-spacing__dimension__68)",
      "76": "var(--dig-spacing__dimension__76)",
      "84": "var(--dig-spacing__dimension__84)",
      "100": "var(--dig-spacing__dimension__100)",
      "116": "var(--dig-spacing__dimension__116)",
      "132": "var(--dig-spacing__dimension__132)"
    },
    "Micro": {
      "XSmall": "var(--dig-spacing__micro__xsmall)",
      "Small": "var(--dig-spacing__micro__small)",
      "Medium": "var(--dig-spacing__micro__medium)",
      "Large": "var(--dig-spacing__micro__large)",
      "XLarge": "var(--dig-spacing__micro__xlarge)"
    },
    "Macro": {
      "XSmall": "var(--dig-spacing__macro__xsmall)",
      "Small": "var(--dig-spacing__macro__small)",
      "Medium": "var(--dig-spacing__macro__medium)",
      "Large": "var(--dig-spacing__macro__large)",
      "XLarge": "var(--dig-spacing__macro__xlarge)"
    }
  },
  "Breakpoint": {
    "XSmall": "var(--dig-breakpoint__xsmall)",
    "Small": "var(--dig-breakpoint__small)",
    "Medium": "var(--dig-breakpoint__medium)",
    "Large": "var(--dig-breakpoint__large)",
    "XLarge": "var(--dig-breakpoint__xlarge)"
  },
  "Color": {
    "Selection Base": "var(--dig-color__selection__base)",
    "Selection Base - State 1": "var(--dig-color__selection__base--state-1)",
    "Selection Base - State 2": "var(--dig-color__selection__base--state-2)",
    "Selection On Base": "var(--dig-color__selection__on-base)",
    "Selection Surface": "var(--dig-color__selection__surface)",
    "Selection Surface - State 1": "var(--dig-color__selection__surface--state-1)",
    "Selection Surface - State 2": "var(--dig-color__selection__surface--state-2)",
    "Selection On Surface": "var(--dig-color__selection__on-surface)",
    "Identity Yellow": "var(--dig-color__identity__yellow)",
    "Identity On Yellow": "var(--dig-color__identity__on-yellow)",
    "Identity Green": "var(--dig-color__identity__green)",
    "Identity On Green": "var(--dig-color__identity__on-green)",
    "Identity Purple": "var(--dig-color__identity__purple)",
    "Identity On Purple": "var(--dig-color__identity__on-purple)",
    "Identity Red": "var(--dig-color__identity__red)",
    "Identity On Red": "var(--dig-color__identity__on-red)",
    "Identity Cyan": "var(--dig-color__identity__cyan)",
    "Identity On Cyan": "var(--dig-color__identity__on-cyan)",
    "Identity Magenta": "var(--dig-color__identity__magenta)",
    "Identity On Magenta": "var(--dig-color__identity__on-magenta)",
    "Identity Blue": "var(--dig-color__identity__blue)",
    "Identity On Blue": "var(--dig-color__identity__on-blue)",
    "Identity Orange": "var(--dig-color__identity__orange)",
    "Identity On Orange": "var(--dig-color__identity__on-orange)",
    "Folder Closed": "var(--dig-color__folder__closed)",
    "Folder Outside": "var(--dig-color__folder__outside)",
    "Folder Inside": "var(--dig-color__folder__inside)",
    "Primary CTA Base": "var(--dig-color__primary-cta__base)",
    "Primary CTA Base - State 1": "var(--dig-color__primary-cta__base--state-1)",
    "Primary CTA Base - State 2": "var(--dig-color__primary-cta__base--state-2)",
    "Primary CTA On Base": "var(--dig-color__primary-cta__on-base)",
    "Background Base": "var(--dig-color__background__base)",
    "Background Subtle": "var(--dig-color__background__subtle)",
    "Background Raised": "var(--dig-color__background__raised)",
    "Text Base": "var(--dig-color__text__base)",
    "Text Subtle": "var(--dig-color__text__subtle)",
    "Border Base": "var(--dig-color__border__base)",
    "Border Subtle": "var(--dig-color__border__subtle)",
    "Border Bold": "var(--dig-color__border__bold)",
    "Border Subtle - On Base": "var(--dig-color__border__subtle--on-base)",
    "Disabled Base": "var(--dig-color__disabled__base)",
    "Disabled On Base": "var(--dig-color__disabled__on-base)",
    "Disabled Surface": "var(--dig-color__disabled__surface)",
    "Disabled On Surface": "var(--dig-color__disabled__on-surface)",
    "Primary Base": "var(--dig-color__primary__base)",
    "Primary Base - State 1": "var(--dig-color__primary__base--state-1)",
    "Primary Base - State 2": "var(--dig-color__primary__base--state-2)",
    "Primary On Base": "var(--dig-color__primary__on-base)",
    "Primary Surface": "var(--dig-color__primary__surface)",
    "Primary Surface - State 1": "var(--dig-color__primary__surface--state-1)",
    "Primary Surface - State 2": "var(--dig-color__primary__surface--state-2)",
    "Primary On Surface": "var(--dig-color__primary__on-surface)",
    "Secondary Base": "var(--dig-color__secondary__base)",
    "Secondary Base - State 1": "var(--dig-color__secondary__base--state-1)",
    "Secondary Base - State 2": "var(--dig-color__secondary__base--state-2)",
    "Secondary On Base": "var(--dig-color__secondary__on-base)",
    "Secondary Surface": "var(--dig-color__secondary__surface)",
    "Secondary Surface - State 1": "var(--dig-color__secondary__surface--state-1)",
    "Secondary Surface - State 2": "var(--dig-color__secondary__surface--state-2)",
    "Secondary On Surface": "var(--dig-color__secondary__on-surface)",
    "Warning Base": "var(--dig-color__warning__base)",
    "Warning Base - State 1": "var(--dig-color__warning__base--state-1)",
    "Warning Base - State 2": "var(--dig-color__warning__base--state-2)",
    "Warning On Base": "var(--dig-color__warning__on-base)",
    "Warning Surface": "var(--dig-color__warning__surface)",
    "Warning Surface - State 1": "var(--dig-color__warning__surface--state-1)",
    "Warning Surface - State 2": "var(--dig-color__warning__surface--state-2)",
    "Warning On Surface": "var(--dig-color__warning__on-surface)",
    "Success Base": "var(--dig-color__success__base)",
    "Success Base - State 1": "var(--dig-color__success__base--state-1)",
    "Success Base - State 2": "var(--dig-color__success__base--state-2)",
    "Success On Base": "var(--dig-color__success__on-base)",
    "Success Surface": "var(--dig-color__success__surface)",
    "Success Surface - State 1": "var(--dig-color__success__surface--state-1)",
    "Success Surface - State 2": "var(--dig-color__success__surface--state-2)",
    "Success On Surface": "var(--dig-color__success__on-surface)",
    "Alert Base": "var(--dig-color__alert__base)",
    "Alert Base - State 1": "var(--dig-color__alert__base--state-1)",
    "Alert Base - State 2": "var(--dig-color__alert__base--state-2)",
    "Alert On Base": "var(--dig-color__alert__on-base)",
    "Alert Surface": "var(--dig-color__alert__surface)",
    "Alert Surface - State 1": "var(--dig-color__alert__surface--state-1)",
    "Alert Surface - State 2": "var(--dig-color__alert__surface--state-2)",
    "Alert On Surface": "var(--dig-color__alert__on-surface)",
    "Opacity Surface": "var(--dig-color__opacity__surface)",
    "Opacity Surface - State 1": "var(--dig-color__opacity__surface--state-1)",
    "Opacity Surface - State 2": "var(--dig-color__opacity__surface--state-2)",
    "Shadow Elevated": "var(--dig-color__shadow__elevated)",
    "Utility Focus Ring": "var(--dig-color__utility__focus-ring)",
    "Utility Overlay": "var(--dig-color__utility__overlay)",
    "Highlight Blue": "var(--dig-color__highlight__blue)",
    "Highlight Blue - Bold": "var(--dig-color__highlight__blue--bold)",
    "Highlight Blue - Bolder": "var(--dig-color__highlight__blue--bolder)",
    "Highlight Purple": "var(--dig-color__highlight__purple)",
    "Highlight Purple - Bold": "var(--dig-color__highlight__purple--bold)",
    "Highlight Purple - Bolder": "var(--dig-color__highlight__purple--bolder)",
    "Highlight Yellow": "var(--dig-color__highlight__yellow)",
    "Highlight Yellow - Bold": "var(--dig-color__highlight__yellow--bold)",
    "Highlight Yellow - Bolder": "var(--dig-color__highlight__yellow--bolder)",
    "Highlight Red": "var(--dig-color__highlight__red)",
    "Highlight Red - Bold": "var(--dig-color__highlight__red--bold)",
    "Highlight Red - Bolder": "var(--dig-color__highlight__red--bolder)",
    "Highlight Green": "var(--dig-color__highlight__green)",
    "Highlight Green - Bold": "var(--dig-color__highlight__green--bold)",
    "Highlight Green - Bolder": "var(--dig-color__highlight__green--bolder)",
    "Accent Cyan": "var(--dig-color__accent__cyan)",
    "Accent Red": "var(--dig-color__accent__red)",
    "Accent Orange": "var(--dig-color__accent__orange)",
    "Accent Green": "var(--dig-color__accent__green)",
    "Accent Blue": "var(--dig-color__accent__blue)",
    "Accent Purple": "var(--dig-color__accent__purple)",
    "Accent Magenta": "var(--dig-color__accent__magenta)",
    "Accent Yellow": "var(--dig-color__accent__yellow)",
    "Accent On Accent": "var(--dig-color__accent__on-accent)",
    "FileIcon Container": "var(--dig-color__fileicon__container)",
    "FileIcon Shadow": "var(--dig-color__fileicon__shadow)",
    "FileIcon Icon": "var(--dig-color__fileicon__icon)",
    "FileIcon Icon Shadow": "var(--dig-color__fileicon__icon-shadow)",
    "FolderIcon Container": "var(--dig-color__foldericon__container)",
    "FolderIcon Shadow": "var(--dig-color__foldericon__shadow)",
    "FolderIcon Icon": "var(--dig-color__foldericon__icon)",
    "FolderIcon Icon Shadow": "var(--dig-color__foldericon__icon-shadow)",
    "Glyph Primary": "var(--dig-color__glyph__primary)",
    "Glyph Accent": "var(--dig-color__glyph__accent)",
    "Illustration Dynamic Line": "var(--dig-color__illustration__dynamic-line)"
  },
  "Radius": {
    "None": "var(--dig-radius__none)",
    "XSmall": "var(--dig-radius__xsmall)",
    "Small": "var(--dig-radius__small)",
    "Medium": "var(--dig-radius__medium)",
    "Large": "var(--dig-radius__large)",
    "XLarge": "var(--dig-radius__xlarge)",
    "Circular": "var(--dig-radius__circular)"
  },
  "Type": {
    "bodyFontStack": "var(--dig-type__bodyfontstack)",
    "titleFontStack": "var(--dig-type__titlefontstack)",
    "monospaceFontStack": "var(--dig-type__monospacefontstack)",
    "Size": {
      "Text": {
        "XLarge": "var(--dig-type__size__text__xlarge)",
        "Large": "var(--dig-type__size__text__large)",
        "Medium": "var(--dig-type__size__text__medium)",
        "Small": "var(--dig-type__size__text__small)",
        "XSmall": "var(--dig-type__size__text__xsmall)"
      },
      "Title": {
        "Large": "var(--dig-type__size__title__large)",
        "Medium": "var(--dig-type__size__title__medium)",
        "Small": "var(--dig-type__size__title__small)"
      },
      "Action": {
        "XLarge": "var(--dig-type__size__action__xlarge)",
        "Large": "var(--dig-type__size__action__large)",
        "Medium": "var(--dig-type__size__action__medium)",
        "Small": "var(--dig-type__size__action__small)"
      }
    },
    "Family": {
      "Text": "var(--dig-type__family__text)",
      "Title": "var(--dig-type__family__title)",
      "Monospace": "var(--dig-type__family__monospace)",
      "Action": "var(--dig-type__family__action)"
    },
    "Weight": {
      "Base": "var(--dig-type__weight__base)",
      "Strong": "var(--dig-type__weight__strong)",
      "Monospace": "var(--dig-type__weight__monospace)",
      "Monospace Strong": "var(--dig-type__weight__monospace-strong)"
    },
    "Lineheight": {
      "Text": {
        "XLarge": "var(--dig-type__lineheight__text__xlarge)",
        "Large": "var(--dig-type__lineheight__text__large)",
        "Medium": "var(--dig-type__lineheight__text__medium)",
        "Small": "var(--dig-type__lineheight__text__small)",
        "XSmall": "var(--dig-type__lineheight__text__xsmall)"
      },
      "Title": {
        "Large": "var(--dig-type__lineheight__title__large)",
        "Medium": "var(--dig-type__lineheight__title__medium)",
        "Small": "var(--dig-type__lineheight__title__small)"
      },
      "Label": {
        "XLarge": "var(--dig-type__lineheight__label__xlarge)",
        "Large": "var(--dig-type__lineheight__label__large)",
        "Medium": "var(--dig-type__lineheight__label__medium)",
        "Small": "var(--dig-type__lineheight__label__small)",
        "XSmall": "var(--dig-type__lineheight__label__xsmall)"
      }
    },
    "Letterspacing": {
      "Action": "var(--dig-type__letterspacing__action)"
    }
  },
  "Utilities": {
    "Boxshadow": {
      "Focus Ring": "var(--dig-utilities__boxshadow__focus-ring)",
      "Inset Focus Ring": "var(--dig-utilities__boxshadow__inset-focus-ring)",
      "Raised": "var(--dig-utilities__boxshadow__raised)",
      "Floating": "var(--dig-utilities__boxshadow__floating)"
    }
  }
};
export {
  tokens as default
};
